import './index.scss';

const blockCtaOrNewsletter = () => {
	(function () {
	    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	    document.querySelectorAll(".block-cat-newsletter-bg-video").forEach(function (video) {
	        if (reducedMotion) { video.removeAttribute("autoplay"); video.pause(); return; }
	        if ("IntersectionObserver" in window) {
	            var obs = new IntersectionObserver(function (entries) {
	                entries.forEach(function (e) {
	                    if (e.isIntersecting) { video.play().catch(function(){}); } else { video.pause(); }
	                });
	            }, { threshold: 0.1 });
	            var sec = video.closest(".block-cat-newsletter-section");
	            if (sec) { obs.observe(sec); }
	        }
	    });
	    document.querySelectorAll(".block-cat-newsletter-bg-iframe-wrap").forEach(function (wrap) {
	        wrap.style.pointerEvents = "none";
	        if (reducedMotion) {
	            var sec = wrap.closest(".block-cat-newsletter-section");
	            if (sec && sec.style.backgroundImage && sec.style.backgroundImage !== "none") { wrap.remove(); }
	        }
	    });
	}());
};

export default blockCtaOrNewsletter;